import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'omk-validation-error',
  styleUrl: 'omk-validation-error.scss',
  shadow: true,
})
export class OmkValidationError {
  @Prop({ reflect: true }) validationMessage: any;
  @Prop() hide: boolean = false;

  render() {
    return (
      <Host class={{ hide: this.hide }} id="error">
        {this.validationMessage}
      </Host>
    );
  }
}
